module.exports = __webpack_public_path__ + "media/images/gallery/constellations/en_layer_off-3566c3f5768c932a03ff1387650be0d5.png";